import { AppShell } from "../../components/layout/AppShell";
import { TeamMembersTab } from "../../components/Dashboard/TeamMembersTab";

export default function TeamMembersPage() {
  return (
    <AppShell>
      <TeamMembersTab />
    </AppShell>
  );
}
